<script>
import PopupBase from './popup-base.vue';
import { langFunction as getLang } from '../../utils/langFunction';

export default {
	components: {
		PopupBase
	},
	extends: PopupBase,
	emits: ['confirm'],
	methods: {
		getLang,
		onConfirm() {
			this.$emit('confirm');
		}
	}
};
</script>
<template>
	<PopupBase
		:popup-id="popupId"
		:popup-title="popupTitle"
	>
		<slot></slot>
		<button 
			class="button button--primary"
			@click="onConfirm"
		>{{ getLang('BASKET_CLEAN_POPUP_CONFIRM') }}</button>
	</PopupBase>
</template>
